var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_40053",
    "data-name": "\\uADF8\\uB8F9 40053",
    transform: "translate(-228 -69)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_35124",
    "data-name": "\\uC0AC\\uAC01\\uD615 35124",
    width: 24,
    height: 24,
    transform: "translate(228 69)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_40012",
    "data-name": "\\uADF8\\uB8F9 40012",
    transform: "translate(-1953.156 2369.896)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_44",
    "data-name": "\\uC120 44",
    x1: 15.75,
    y2: 15.75,
    transform: "translate(2185.221 -2296.712)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_45",
    "data-name": "\\uC120 45",
    x1: 15.75,
    y1: 15.75,
    transform: "translate(2185.221 -2296.712)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4714",
    "data-name": "\\uC0AC\\uAC01\\uD615 4714",
    width: 24,
    height: 24,
    transform: "translate(2181.156 -2300.896)",
    fill: "none",
    opacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteX);
export default __webpack_public_path__ + "static/media/white_x.a355a6c2857b056e0d50e4c18cbae5bd.svg";
export { ForwardRef as ReactComponent };